export default __webpack_public_path__ + "static/media/insurance.4b15614e.svg";